import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({providedIn: 'root'})
export class EmailService {
  constructor(private httpClient: HttpClient) { }
  
  public sendEmail(body: FormData) {
    const url = environment.emailUrl;
    return this.httpClient.post(`${url}/send-attachment-by-email`, body);
  }
}